import { getCookie } from '../util/cookie';
import { hideLoadingOverlay, showLoadingOverlay } from '../util/loading-overlay';
import { log } from '../util/log';
import { track } from '../util/tracking';
import { loadSelectLocationPage } from './pages/select-location';

document.addEventListener('DOMContentLoaded', loadGiftCardBuilder);

const SELECTOR_ROOT_ELEMENT = '.wp-block-silk-nexus-wp-plugin-gift-card-builder .booking-content';

async function loadGiftCardBuilder() {
	// @ts-ignore
	if (!window.bootstrap) {
		// @ts-ignore
		window.bootstrap = {
			// @ts-ignore
			Modal: window.Modal,
		};
	}

	const root = document.querySelector<HTMLElement>(SELECTOR_ROOT_ELEMENT);
	if (!root) {
		log('Gift Card Builder not found');
		return;
	}

	log('Loading gift card builder');
	showLoadingOverlay(context);
	context.root.innerHTML = '';
	const ssrStartTime = performance.now();
	const ssrResponse = await callWp('GET', 'view_choose_services', context.data);
	const ssrEndTime = performance.now();
	log('SSR took', ssrEndTime - ssrStartTime, 'ms');
	const html = ssrResponse.html;
}
